import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { Link } from 'react-router-dom';
import toMomentObject from 'react-dates/lib/utils/toMomentObject';
import toISODateString from 'react-dates/lib/utils/toISODateString';
import DatepickerSeparated from 'components/DatepickerSeparated';
import Dropdown from 'react-dropdown';
import Page from 'pages/Page';
import Button from 'components/common/Button';
import H6Text from 'components/common/H6Text';
import ListingPageSection from 'components/ListingPageSection';
import ListingCarousel from 'components/ListingCarousel';
import ListingTotal from 'components/ListingTotal';
import Amenities from 'components/Amenities';
import WideP from 'components/common/WideP';
import SingleListingCarousel from 'components/SingleListingCarousel';
import ListingGeneralInfo from 'components/ListingGeneralInfo';
import Spinner from 'components/common/Spinner';
import { getPriceStr, getPercent } from 'utils';

function getGuestItems(guestCount) {
  const arr = new Array(guestCount);
  for (let i=0; i<guestCount; i++) {
    arr[i] = i+1;
  }
  return arr;
}


export default class ListingPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      focusedInput: null
    };
  }

  componentWillMount() {
    this.props.fetchCalendar(
      this.props.listing._id,
      toISODateString(toMomentObject(new Date())),
      toISODateString(toMomentObject(new Date()).add(6, 'months'))
    );

    this.props.updateActiveListing(this.props.listing._id);
  }

  onNextMonthClick() {
    console.log("next month clicked");
  }

  onPrevMonthClick() {
    console.log("prev month clicked");
  }

  render() {
    const { pageTitle, listing, startDate, endDate, guests, onDateChange, onGuestChange, similar, query, bookedDays, color, numberOfMonths } = this.props;
    const { focusedInput } = this.state;
    const {
      _id,
      title,
      accommodates,
      reservation: { cleaningFee, basePrice, currency, fareAccommodation, pricePerNight, nightsCount, totalPrice },
      publicDescription: { space, access, interactionWithGuests, houseRules },
      defaultCheckInTime,
      defaultCheckOutTime,
      prices: { weeklyPriceFactor, monthlyPriceFactor, extraPersonFee },
      amenities,
      pictures,
      pending
    } = listing;

    const fareAccommodationOrBasePrice = fareAccommodation || basePrice;
    const basePriceStr = getPriceStr(fareAccommodationOrBasePrice, currency);
    const pricePerNightOrBasePrice = pricePerNight || basePrice;
    const pricePerNightStr = getPriceStr(pricePerNightOrBasePrice, currency);
    const checkinTime = defaultCheckInTime;
    const checkoutTime = defaultCheckOutTime;
    const cleaningFeeStr = getPriceStr(cleaningFee, currency);

    const hasDates = startDate && endDate;
    const totalPriceStr = getPriceStr(totalPrice, currency);
    const weeklyDiscount = weeklyPriceFactor < 1 ? getPercent(weeklyPriceFactor) : null;
    const monthlyDiscount = monthlyPriceFactor < 1 ? getPercent(monthlyPriceFactor) : null;
    const pplPrice = extraPersonFee ? getPriceStr(extraPersonFee, currency) : null;

    return (
    <Page title={pageTitle}>
      <div className="listing-page">
          <div className="row no-gutters listing-title-row">
            <div className="col-lg-8">
              <SingleListingCarousel pictures={pictures}/>
            </div>
            <div className="col-lg-4 bg-inverse">
              <div className="container p-45">
                <div className="row no-gutters pb-45 separator">
                  <div className="col mr-45">
                    <h3 className="mb-0">{title}</h3>
                  </div>
                  <div className="col-auto text-right">
                    <h3 className="mb-25">{pricePerNightStr}</h3>
                    <div>per night</div>
                  </div>
                </div>

                <div className="mb-lg-25 mb-45 mt-35">
                  <DatepickerSeparated
                    startDate={startDate} // momentPropTypes.momentObj or null,
                    endDate={endDate} // momentPropTypes.momentObj or null,
                    onDatesChange={onDateChange} // PropTypes.func.isRequired,
                    focusedInput={focusedInput} // PropTypes.oneOf([START_DATE, END_DATE]) or null,
                    onFocusChange={focusedInput => this.setState({ focusedInput })} // PropTypes.func.isRequired,
                    onNextMonthClick={this.onNextMonthClick}
                    onPrevMonthClick={this.onPrevMonthClick}
                    disabled={!bookedDays}
                    isDayBlocked={day => {
                      return bookedDays ? bookedDays.some(day2 => !day2.diff(day)) : false
                    }}
                    numberOfMonths={numberOfMonths}
                  />
                </div>
                <div className="mb-35">
                  <Dropdown placeholder="Guests" options={getGuestItems(accommodates)} value={guests && String(guests)} onChange={onGuestChange}/>
                </div>
                { hasDates && (
                  <div style={{marginBottom:25, position: 'relative'}}>
                    <div style={pending ? { opacity: 0} : {}}>
                      <ListingTotal pricePerNight={pricePerNightStr} basePrice={basePriceStr} totalPrice={totalPriceStr} cleaningFee={cleaningFeeStr} nights={nightsCount}/>
                    </div>
                    { pending && <div style={{ position: 'absolute', top: 0, right: 0, bottom: 0, left: 0}} className="d-flex justify-content-center align-items-center"><Spinner small={true}/></div>}
                  </div>
                )}
                <Link to={`/listings/${_id}/book?${query}`} className="d-block">
                  <Button className="col submit-btn" isDisabled={!hasDates || !guests} style={{background: color}}>Book</Button>
                </Link>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row no-gutters">
              <div className="col-lg-10 offset-lg-1">

            <ListingGeneralInfo listing={listing} />

            <ListingPageSection color={color}>
              <div className="row no-gutters pb-5">
                <div className="col-sm">
                  <h5>Check in and out</h5>
                  <WideP>
                    Check in: {checkinTime}<br/>
                    Check out: {checkoutTime}
                  </WideP>
                </div>
                { (weeklyDiscount || monthlyDiscount || pplPrice) && <div className="col-sm">
                  <h5>Prices</h5>
                  <WideP>
                    { weeklyDiscount && <div>Weekly discount: {weeklyDiscount}</div> }
                    { monthlyDiscount && <div>Monthly discount: {monthlyDiscount}</div> }
                    { pplPrice && <div>Extra people: {`${pplPrice} per night`}</div> }
                  </WideP>
                </div> }
              </div>
            </ListingPageSection>

            <ListingPageSection expandable={true} minHeight={250} maxHeight={3000} color={color}>
              <h5>Amenities</h5>
              <Amenities amenities={amenities}/>
            </ListingPageSection>

            <ListingPageSection expandable={true} minHeight={242} maxHeight={3000} color={color}>
              <div className="row">
                <div className="col-sm">
                  <h5 className="mb-5">Description</h5>
                  <H6Text>The Space</H6Text>
                  <p>{space}</p>
                  <H6Text>Guest Access</H6Text>
                  <p>{access}</p>
                  <H6Text>Interaction</H6Text>
                  <p>{interactionWithGuests}</p>
                </div>
                <div className="col-sm">
                  <h5 className="mb-5">Staying Rules</h5>
                  <p>{houseRules}</p>
                </div>
              </div>
            </ListingPageSection>
              </div>
            </div>

            {!isEmpty(similar) && (
              <div>
                <h3 className="text-center mt-6">Suggested listings</h3>
                <div className="mb-6">
                  <ListingCarousel listings={similar} />
                </div>
              </div>
            )}
          </div>
      </div>
    </Page>);
  }
}


// WEBPACK FOOTER //
// ./src/pages/ListingPage.js